/**
 * Incident Party API Client (PROJ-007)
 * Manages affected parties (persons and companies) linked to incidents
 */

import { apiRequest } from './standard-api';
import type {
  IncidentParty,
  ListIncidentPartiesParams,
  AddIncidentPartyPayload
} from '@/types/incidentParty';

/**
 * List parties for an incident
 */
export async function listIncidentParties(
  incidentId: string,
  params?: ListIncidentPartiesParams
): Promise<IncidentParty[]> {
  const queryParams = new URLSearchParams();

  if (params?.includeDetails !== undefined)
    queryParams.set('includeDetails', params.includeDetails.toString());
  if (params?.role) queryParams.set('role', params.role);

  const query = queryParams.toString();
  const url = `/api/v1/incidents/${incidentId}/parties${query ? `?${query}` : ''}`;

  const response = await apiRequest<IncidentParty[]>(url);
  return response.data;
}

/**
 * Add a party to an incident
 */
export async function addIncidentParty(
  incidentId: string,
  payload: AddIncidentPartyPayload
): Promise<IncidentParty> {
  const response = await apiRequest<IncidentParty>(
    `/api/v1/incidents/${incidentId}/parties`,
    {
      method: 'POST',
      body: JSON.stringify(payload)
    }
  );
  return response.data;
}

/**
 * Remove a party from an incident
 */
export async function removeIncidentParty(
  incidentId: string,
  partyId: string
): Promise<IncidentParty> {
  const response = await apiRequest<IncidentParty>(
    `/api/v1/incidents/${incidentId}/parties/${partyId}`,
    {
      method: 'DELETE'
    }
  );
  return response.data;
}
